import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'age',
  standalone: true
})
export class AgePipe implements PipeTransform {

  transform(value: Date | string | undefined): number | string {

    let birthday: Date | undefined = undefined

    if (typeof value === "object") {
      birthday = value
    }

    if (typeof value === "string") {
     birthday = this.parseStringValue(value)
    }

    if (birthday === undefined) {
      return "Invalid Date"
    }

    const today = new Date()

    let age = today.getFullYear() - birthday.getFullYear()

    if (today.valueOf() > birthday.valueOf()) {
      age--
    }
   return age

  }


  parseStringValue(value: string) {
   let returnDate: Date | undefined = undefined

    let dateTime = DateTime.fromISO(value).setZone("local", { keepLocalTime: true })

    if (!dateTime.isValid) {
      dateTime = DateTime.fromFormat(value, "yyyy-MM-dd")
    }

    if (dateTime.isValid) {
      returnDate = dateTime.toJSDate()
    }

    return returnDate
  }

}
